import { type JSX } from "react";
import {
  IconNavDashboard,
  IconNavThemes,
  IconNavUsers,
  IconNavSettings,
  IconNavWarning,
  IconNavDoc,
  IconNavDilemma,
  IconNavHistory,
  IconNavInformations,
  IconNavSubmissions,
} from "./icons";

const Icon = ({ icon }: { icon: string }) => {
  const icons: Record<string, JSX.Element> = {
    dashboardIcon: <IconNavDashboard />,
    themesIcon: <IconNavThemes />,
    usersIcon: <IconNavUsers />,
    settingsIcon: <IconNavSettings />,
    warningIcon: <IconNavWarning />,
    docIcon: <IconNavDoc />,
    dilemmaIcon: <IconNavDilemma />,
    historyIcon: <IconNavHistory />,
    informationsIcon: <IconNavInformations />,
    submissionsIcon: <IconNavSubmissions />,
  };
  return (
    <div className="flex items-center justify-center w-7">{icons[icon]}</div>
  );
};
export default Icon;
